import React from 'react';
import { useNavigate } from 'react-router';
import { object, string } from 'yup';

import Form, { Botao, Campo } from 'Component/Form';
import Icone from 'Component/Icone';
import { LayoutLogin } from 'Component/Layout';
import Usuario from 'Interface/Usuarios';
import { login as loginAction } from 'Reducer/Autenticacao';
import { useLoginMutation } from 'Service';
import { useAppDispatch } from 'Store';
import { MASCARA_CPF } from 'View/constants';

const regras = object({
  cpf: string().required('Obrigatório'),
  senha: string().required('Obrigatório'),
});

const Login = (): React.ReactElement => {
  const navegacao = useNavigate();
  const dispatch = useAppDispatch();
  const [login] = useLoginMutation();

  const enviar = async (dados: Usuario): Promise<void> => {
    try {
      const resposta = await login(dados).unwrap();

      dispatch(loginAction(resposta));

      navegacao('/inicio');
    } catch (erro) {
      console.log(erro);
    }
  };

  return (
    <LayoutLogin>
      <div className="w-100">
        <h1 className="mb-4">Login</h1>
        <Form onSubmit={enviar} regras={regras}>
          <Campo
            name="cpf"
            type="text"
            rotulo="CPF"
            prefixar={<Icone nome="person-fill" />}
            mascara={MASCARA_CPF}
          />
          <Campo
            name="senha"
            type="password"
            rotulo="Senha"
            prefixar={<Icone nome="lock-fill" />}
          />

          <Botao>Enviar</Botao>
        </Form>
      </div>
    </LayoutLogin>
  );
};

export default Login;
